import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CodeInputModule } from 'angular-code-input';

@Component({
  selector: 'app-forgot-password-pin-step',
  templateUrl: './pin-reset-step.component.html',
  styleUrls: ['./pin-reset-step.component.scss'],
  imports: [TranslatePipe, CodeInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PinResetStepComponent {
  public pinSubmit = output<string>();

  public passcodeValue = signal({
    passcode: '',
    confirmPasscode: '',
    valid: false,
  });

  public enterPasscode(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      passcode: password,
      valid: password === value.confirmPasscode && password.length === 4 && value.confirmPasscode.length === 4,
    }));
  }

  public enterConfirmPasscode(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      confirmPasscode: password,
      valid: value.passcode === password && value.passcode.length === 4 && password.length === 4,
    }));
  }

  public resetPassword(): void {
    this.pinSubmit.emit(this.passcodeValue().passcode);
  }
}
